// A free upload preview of a video over 30 minutes covers only its first 30 (the collector cuts it and
// keeps the full length in preview_full_seconds). These say so on the workspace page.

// 1800 → "30:00", 4440 → "1:14:00"
export const fmtClock = seconds => {
  const s = Math.max(0, Math.round(seconds || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const rest = String(s % 60).padStart(2, '0');
  return h ? `${h}:${String(m).padStart(2, '0')}:${rest}` : `${m}:${rest}`;
};

// What a cut preview's page says: null when the workspace isn't one
export function trimmedPreviewNote({ fullSeconds, coveredSeconds, isPro }) {
  if (!fullSeconds || !(fullSeconds > coveredSeconds)) return null;
  const covered = fmtClock(coveredSeconds);
  const full = fmtClock(fullSeconds);
  return isPro
    ? { lead: `This workspace covers the first ${covered}`, rest: ` of your ${full} video. Upload it again to process all of it (${Math.max(Math.ceil(fullSeconds / 60), 1)} minutes).`, action: 'upload' }
    : { lead: `Free preview of the first ${covered}`, rest: ` of this ${full} video. Pro processes the whole video.`, action: 'plans' };
}
